import * as React from "react";
import {CSSProperties} from "react";


interface Props {
  title: string;
  style?: CSSProperties;
}

class ChecklistTypeLabel extends React.Component<Props, {}> {

  public render(): React.ReactNode {
    const {title, style} = this.props;

    return (
      <div style={{
        marginRight: 16,
        flexShrink: 0,
        flexGrow: 0,
        flexBasis: 'auto',
        width: 90,
        color: 'var(--color-medium-gray)',
        fontSize: 'small',
        ...style,
      }}>
        {title}
      </div>
    );
  }
}

export default ChecklistTypeLabel;


// WEBPACK FOOTER //
// ./src/checklist/ChecklistTypeLabel.tsx